import { render } from "./CommentReportForm.vue?vue&type=template&id=6b555b22&scoped=true"
import script from "./CommentReportForm.vue?vue&type=script&lang=js"
export * from "./CommentReportForm.vue?vue&type=script&lang=js"

import "./CommentReportForm.vue?vue&type=style&index=0&id=6b555b22&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b555b22"]])

export default __exports__